<template>
  <v-row no-gutters>
    <v-col cols="12" class="pr-6">
      <card-title-row :straightTitle="additionalModuleName" class="pt-5" />
      <card-title-row translation-path="sidebar.failureAnnouncements.repairDate" is-subtitle class="mt-5 mb-3" />
      <sidebar-row>
        <v-row no-gutters>
          <v-col cols="6">
            <data-input
              v-model="repairDate"
              :data-type="{ name: 'date' }"
              prepend-inner-icon="mdi-calendar"
              hide-details
              clearable
            />
          </v-col>
        </v-row>
      </sidebar-row>
      <sidebar-row class="pt-5">
        <v-row no-gutters>
          <v-col cols="auto">
            <base-button
              translation-path="sidebar.failureAnnouncements.generateAnnouncement"
              :disabled="!repairDate"
              class="mr-0"
              @click="generateAnnouncement()"
            />
          </v-col>
        </v-row>
      </sidebar-row>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import CardTitleRow from '@/components/CardTitleRow';
import SidebarRow from '@/components/SidebarRow';
import DataInput from '@/components/DataInput';

export default {
  name: 'FailureAnnouncements',
  components: { CardTitleRow, SidebarRow, DataInput },
  data: () => ({
    repairDate: null,
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@FAILURE_ANNOUNCEMENTS.verbose_name'),
  },
  methods: {
    generateAnnouncement() {
      const repairDate = this.repairDate
        .split('-')
        .reverse()
        .join('.');
      if (pdfMake.vfs === undefined) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      const docDefinition = {
        pageOrientation: 'landscape',
        pageMargins: [0, 125],
        content: [
          this.$i18n.t('sidebar.failureAnnouncements.announcementPrependText'),
          { text: repairDate, style: 'repairDate', margin: [0, 50] },
          this.$i18n.t('sidebar.failureAnnouncements.announcementAppendText'),
        ],
        defaultStyle: {
          fontSize: 48,
          alignment: 'center',
        },
        styles: {
          repairDate: {
            fontSize: 72,
            bold: true,
          },
        },
      };
      pdfMake.createPdf(docDefinition).download(this.$i18n.t('sidebar.failureAnnouncements.announcement'));
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-text-field__slot {
  padding-left: 10px;
}
</style>
